import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WaiterBottomSheet from './WaiterBottomSheet';
import icons from '../icons/Icons';
import './FloatingWaiterButton.css';

const FloatingWaiterButton = () => {
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            
            // Show button when scrolling up, hide when scrolling down
            if (currentScrollY < lastScrollY) {
                setIsVisible(true);
            } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setIsVisible(false);
            }
            
            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    const handleButtonClick = () => {
        setIsBottomSheetOpen(true);
    };

    const handleCloseBottomSheet = () => {
        setIsBottomSheetOpen(false);
    };

    return (
        <>
            <button 
                className={`floating-waiter-btn ${isVisible ? 'visible' : 'hidden'}`}
                onClick={handleButtonClick}
                aria-label="Call Waiter"
            >
                <FontAwesomeIcon 
                    icon={icons.userTie} 
                    size="lg"
                />
            </button>
            
            <WaiterBottomSheet 
                isOpen={isBottomSheetOpen} 
                onClose={handleCloseBottomSheet}
            />
        </>
    );
};

export default FloatingWaiterButton;
